export default __webpack_public_path__ + "static/media/reproducir-sonido.d1744f9d.svg";